import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { HelixPalette, HelixStyles } from '../../helix';
import { HELIX_REACT_CORE_TRANSLATION_NAMESPACE } from '../../locales';
import { Button } from '../Button';
import { ICross, ITick } from '../Iconography';
import './Chip.scss';
/**
 * Clickable Chip component.
 */
export const Chip = ({ dataId, disabled = false, checked = false, color = 'grey', icon, label, onClick, onDismiss, style, type = 'static', }) => {
    // Hooks.
    const { t } = useTranslation();
    const labelText = (_jsx(Typography, Object.assign({}, HelixStyles.style_11_bold, { "data-id": `${dataId}-label`, component: "div", whiteSpace: "nowrap", margin: "auto", color: 'inherit' }, { children: _jsx("b", { children: label }) })));
    if (type === 'action') {
        return (_jsxs("button", Object.assign({ "data-id": dataId, className: `chip ${type} ${color} ${checked ? 'selected' : ''}`, onClick: onClick, "aria-selected": checked, disabled: disabled, style: style }, { children: [checked && _jsx(ITick, { color: HelixPalette.white }), icon, label && labelText] })));
    }
    else {
        return (_jsxs("div", Object.assign({ "data-id": dataId, className: `chip ${type} ${color}`, style: style }, { children: [icon, label && labelText, type == 'input' && (_jsx(Button, { dataId: `${dataId}-clear`, title: t('commands.clear', { ns: HELIX_REACT_CORE_TRANSLATION_NAMESPACE }), onClick: onDismiss, type: "universal", leftIcon: _jsx(ICross, {}), variant: color == 'teal' ? 'teal' : 'grey' }))] })));
    }
};
export default Chip;
